export enum DynamicPagesTypes {
  termsAndConditions = 'TERMS_AND_CONDITIONS',
  aboutUs = 'ABOUT_US',
  privacyAndPolicy = 'PRIVACY_AND_POLICY',
}
